import { createDefaultOffersHubState } from './defaults';
import type { OffersHubPayloadBuilderState } from './types';

function snapshotOffersHubState(state: OffersHubPayloadBuilderState): string {
  return JSON.stringify({
    heroCarouselItems: state.heroCarouselItems.map((item) => ({
      isActive: item.isActive,
      eligibleRegions: [...item.eligibleRegions].sort(),
      startAt: item.startAt,
      endAt: item.endAt,
      label: item.label.trim(),
      imageId: item.imageId.trim(),
      logoImageId: item.logoImageId.trim(),
      title: item.title.trim(),
      description: item.description.trim(),
      ctaLabel: item.ctaLabel.trim(),
      ctaUrl: item.ctaUrl.trim(),
    })),
    offers: state.offers.map((offer) => ({
      isActive: offer.isActive,
      eligibleRegions: [...offer.eligibleRegions].sort(),
      startAt: offer.startAt,
      endAt: offer.endAt,
      offerTag: offer.offerTag,
      brandName: offer.brandName.trim(),
      industry: offer.industry.trim(),
      imageId: offer.imageId.trim(),
      title: offer.title.trim(),
      description: offer.description.trim(),
      ctaLabel: offer.ctaLabel.trim(),
      ctaUrl: offer.ctaUrl.trim(),
      urgencyType: offer.urgencyType,
    })),
  });
}

/** Returns true when the user has entered or changed any Offers Hub values from defaults. */
export function hasOffersHubProgress(state: OffersHubPayloadBuilderState, loadJson: string): boolean {
  if (loadJson.trim()) return true;
  return snapshotOffersHubState(state) !== snapshotOffersHubState(createDefaultOffersHubState());
}
